// i18n system
import en from './en.js';
import ja from './ja.js';
import ko from './ko.js';
import de from './de.js';
import es from './es.js';
import pt from './pt.js';
import fr from './fr.js';
import zhTW from './zh-TW.js';
import th from './th.js';

export type Locale = 'en' | 'ja' | 'ko' | 'de' | 'es' | 'pt' | 'fr' | 'zh-TW' | 'th';

export const SUPPORTED_LOCALES: Locale[] = ['en', 'ja', 'ko', 'de', 'es', 'pt', 'fr', 'zh-TW', 'th'];

const STORAGE_KEY = 'crypto-clicker-locale';

const translations: Record<Locale, Record<string, string>> = {
 en,
 ja,
 ko,
 de,
 es,
 pt,
 fr,
 'zh-TW': zhTW,
 th,
};

let currentLocale: Locale = 'en';

export function detectLocale(): Locale {
 try {
 const saved = (typeof localStorage !== 'undefined' ? localStorage.getItem(STORAGE_KEY) : null) as Locale;
 if (saved && SUPPORTED_LOCALES.includes(saved)) return saved;

 if (typeof navigator !== 'undefined') {
 const langs = navigator.languages?.length ? navigator.languages : [navigator.language];
 for (const lang of langs) {
 const normalized = lang.toLowerCase();
 const exact = SUPPORTED_LOCALES.find(loc => loc.toLowerCase() === normalized);
 if (exact) return exact;
 const langBase = normalized.split('-')[0];
 const baseMatch = SUPPORTED_LOCALES.find(loc => loc.toLowerCase().split('-')[0] === langBase);
 if (baseMatch) return baseMatch;
 }
 }
 return 'en';
 } catch {
 return 'en';
 }
}

export function setLocale(locale: Locale): void {
 currentLocale = locale;
 try { localStorage.setItem(STORAGE_KEY, locale); } catch { /* */ }
 try { document.documentElement.lang = locale; } catch { /* */ }
}

export function getCurrentLocale(): Locale {
 return currentLocale;
}

export function t(key: string): string {
 return translations[currentLocale]?.[key] || translations.en[key] || key;
}

/** t() with {placeholder} interpolation, e.g. tv('cnews_listing', { coin: 'MoonFrog' }) */
export function tv(key: string, vars: Record<string, string>): string {
 let text = t(key);
 for (const [name, value] of Object.entries(vars)) {
 text = text.split(`{${name}}`).join(value);
 }
 return text;
}

// Initialize
currentLocale = detectLocale();
try { document.documentElement.lang = currentLocale; } catch { /* */ }
